import React, { useEffect } from "react";
// @ts-ignore
import Cookies from "js-cookie";
import { useForm, FieldErrors } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { ToastContainer, toast } from "react-toastify";
// @ts-ignore
import "react-toastify/dist/ReactToastify.css";
import { toastOptions } from "../../features/toast/toast";
import Loading from "../../components/loading/loading";
import { getAuthToken } from "../../services/auth/sepToken";
import { MakePay } from "../../services/charge/makePay";


const Make = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<any>({
        defaultValues: {
            mobile: Cookies.get("mobileNumber") || "",
            merchantCode: Cookies.get("nationalCode") || "",
        },
    });

    const mutation = useMutation({
        mutationFn: MakePay,
        onSuccess: (data) => {
            if (data.statusCode === 200) {
                window.open(`https://${data.message}`, '_self')
            }
            else {
                toast.error(data?.message, toastOptions);
            }
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        },
    });

    const onSubmit = (data: any) => {
        data.cellOp = "MTN"
        mutation.mutate(data);
    };

    const onError = (errors: FieldErrors<any>) => {
        const uniqueErrorMessages = new Set<string>();
        Object.values(errors).forEach((error) => {
            if (error?.message) {
                uniqueErrorMessages.add(error.message as string);
            }
        });
        if (errors?.birthDay) {
            toast.error("یکی از فیلدای تاریخ تولد رو فراموش کردی", toastOptions);
        }
        if (errors?.number) {
            toast.error("یکی از فیلدای شماره کارت رو فراموش کردی", toastOptions);
        }
        uniqueErrorMessages.forEach((message) => {
            toast.error(message, toastOptions);
        });
    };

    useEffect(() => {
        getAuthToken('HashinGoldClient').then((response) => {
            Cookies.set('makeToken', response.access_token)
        })
    }, []);

    const validateNationalCode = (value: any) => {
        if (!/^\d{10}$/.test(value)) {
            return 'کد ملی باید ده رقم باشد';
        }

        const check = +value[9];
        const sum = [...value].slice(0, 9)
            .map((num, index) => +num * (10 - index))
            .reduce((a, b) => a + b, 0);

        const remainder = sum % 11;

        if ((remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder)) {
            return true;
        }

        return 'کد ملی معتبر نیست';
    };
    return (
        <>
            {mutation.isPending ? (
                <div
                    style={{ height: "100dvh" }}
                    className="d-flex h-100 align-items-center justify-content-center"
                >
                    <Loading />
                </div>
            ) : (
                <>
                    <section className="container pb-3 h-100" style={{ height: '100dvh' }}>
                        <div className="row h-100 justify-content-center align-items-center overflow-x-hidden">
                            <div className="col-lg-5 col-md-7 col-12">
                                <form onSubmit={handleSubmit(onSubmit, onError)}>
                                    <fieldset className="mt-md-5 mt-4">
                                        <label className="form-label text-white mb-3">
                                            شماره موبایل
                                        </label>
                                        <input
                                            maxLength={11}
                                            type="tel"
                                            id="telephone"
                                            className={`form-control ${errors.mobileNumber ? 'border border-danger border-3' : ''}`}
                                            {...register("mobile", {
                                                required: "شماره موبایل الزامی است",
                                                validate: (val: string) => {
                                                    const fullMobile = val.startsWith("09") ? val : "09" + val;
                                                    if (!/^09\d{9}$/.test(fullMobile)) return "شماره موبایل معتبر نیست";
                                                    return true;
                                                },
                                                maxLength: {
                                                    value: 11,
                                                    message: "شماره موبایل نباید بیشتر از 11 رقم باشد"
                                                },
                                            })}
                                        />
                                    </fieldset>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            کد ملی‌
                                        </label>
                                        <input
                                            maxLength={10}
                                            id="code"
                                            type="tel"
                                            className={`form-control ${errors.nationalCode ? 'border border-danger border-3' : ''}`}
                                            {...register("merchantCode", {
                                                required: "فیلد کد ملی الزامی است",
                                                validate: validateNationalCode,
                                            })}
                                        />
                                    </fieldset>
                                    <fieldset className="mt-3">
                                        <label className="form-label text-white mb-3">
                                            مبلغ
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("amount", {
                                                required: false,
                                            })}
                                        />
                                    </fieldset>
                                    <div className="d-flex justify-content-end mt-3">
                                        <button
                                            type="submit"
                                            disabled={mutation.isPending}
                                            className="btn form-btn fw-bold rounded rounded-pill p-2 px-4"
                                        >
                                            {mutation.isPending ? (
                                                <>
                                                    در حال ارسال
                                                    <span className="spinner-border spinner-border-sm ms-2"></span>
                                                </>
                                            ) : (
                                                <>
                                                    ادامه
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12.7801 6.31005C15.6501 4.66005 18.0001 6.01005 18.0001 9.33005V12V14.67C18.0001 17.98 15.6501 19.34 12.7801 17.68L10.4701 16.34L8.16007 15C5.29007 13.34 5.29007 10.63 8.16007 8.97005"
                                                            stroke="#171717"
                                                            strokeWidth="2"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </>
            )
            }
            <ToastContainer />
        </>
    );
};

export default Make;
